module.exports = __webpack_public_path__ + "img/fw100.prt.7002c349.jpg";